import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UserSettings, Workspace} from '../../../global/user-settings.dto';
import {UserTimezone} from '../../signing-pages/signing-page/signing-page.dto';
import { Subject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})

export class ProfileService {

    public workSpaceChangeDetection$ = new Subject<{shouldRefreshProfile: boolean}>();

    constructor(private http:HttpClient){}

    /**
     * Build user profile data after merging user settings and workspace data
     * @param user_settings
     * @param workSpace
     * @returns Users profile data
     */
    buildUserProfileData(user_settings: UserSettings, workSpace: Workspace) {
        const {
            id,
            name,
            email,
            phone,
            tenant_owner,
        } = user_settings;

        let billing_country, vat_number;
        if (user_settings?.tenant) {
            ({ billing_country, vat_number } = user_settings.tenant);
        }
        const commonProfileData = {
            name,
            email,
            phone,
            tenant_owner,
        };
        return workSpace?.is_organization
            ? {
                ...workSpace,
                ...commonProfileData,
                workspace_name: workSpace?.name,
                billing_country,
                vat_number,
            }
            : {
                ...user_settings.tenant,
                workspace_name: workSpace?.name,
                id,
                ...commonProfileData,
            };
    }

    /**
     * Get profile data
     * @returns response
     */
    getProfileData(){
        return this.http.get('users/singleuser');
    }



    /**
     * Update profile data
     * @param formData 
     * @returns response
     */
    updateProfile(formData:FormData){
        return this.http.post<UserSettings>('users/profileupdate', formData);
    }



    /**
     * Update password
     * @param formData 
     * @returns response
     */
    updatePasswrod(formData){
        return this.http.post('users/changepassword', formData);
    }



    /**
     * Get notifications setting
     * @returns response
     */
    notifications(){
        return this.http.get('notifications');
    }
    


    /**
     * Create and update notification setting
     * @param formData 
     * @returns response
     */
    saveNotificationSettings(formData){
        return this.http.post('notifications', formData);
    }
    

    /**
     * Get timeZone setting
     * @returns response
     */
    timezones(){
        return this.http.get<UserTimezone>('timezones');
    }


    /**
     * Create and update timeZone setting
     * @param formData 
     * @returns response
     */
    saveTimeZoneSetting(formData){
        return this.http.post('timezones', formData);
    }


    /**
     * Get user signature
     * @returns response
     */
    getSignature(){
        return this.http.get('users/signature');
    }


    /**
     * Create and update signature
     * @param formData 
     * @returns response
     */
    createOrUpdatesignature(formData){
        return this.http.post('users/signature', formData);
    }



    setWorkSpaceChangesTrigger(shouldRefreshProfile: boolean){
        this.workSpaceChangeDetection$.next({shouldRefreshProfile: shouldRefreshProfile});
    }


    getWorkSpaceChanges(){
        return this.workSpaceChangeDetection$.asObservable();
    }
}

export interface IUpdateProfileDataForm {
    id?:number;
    name:string;
    email:string;
    organization?:string;
    registration_number?:string;
    phone:string;
    profile_image?:string;
    status?:string;
    signature?:string;
    address?:string;
    zipcode?:string;
    city?:string;
    billing_country?:string;
    vat_number?:string;
    industry?:string;
    workspace_name: string
}
